import { Button, Modal } from '@/components'

export function RemovePortModal(props: { open: boolean; onOk: () => void; onClose: () => void }) {
  const { onOk, onClose, open } = props

  return (
    <Modal
      className="w-[640px]"
      open={open}
      onClose={() => {
        onClose && onClose()
      }}
    >
      <Modal.Header>Delete Confirmation</Modal.Header>
      <Modal.Body>
        <div className="bg-neutral-50 t-sm text-secondary p-4 rounded-lg">
          You are about to delete this port permanently. Are you sure?
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button type="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button
          type="danger"
          onClick={() => {
            onOk()
            onClose()
          }}
          className="bg-error"
        >
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
